import React from 'react';
import classnames from 'classnames';

import { Button } from 'components/button/Button';
import { IconButton } from 'components/button/IconButton';
import { MegaButton } from 'components/button/MegaButton';
import { Segment } from 'components/elements/segment/Segment';

import s from './Buttons.module.scss';

export const Buttons = () => {
  const colors = ['brand', 'white', 'dark'];
  const buttons = [
    <Button>Button</Button>,
    <IconButton icon="plus" />,
    // <IconButton icon="mail">Send</IconButton>,
    <IconButton>Button</IconButton>,
  ];
  const megaButtons = [
    <MegaButton ariaLabel="MegaButton">MegaButton</MegaButton>,
    <MegaButton
      label="View"
      caption="Robert Wessman"
      subline="Chairman and CEO"
      ariaLabel="Strategic Roadmap"
    >
      Strategic Roadmap
    </MegaButton>,
    <MegaButton number="256" label="Explore" ariaLabel="256 Generic projects in pipeline">
      <p>
        Generic projects
        <br />
        in pipeline
      </p>
    </MegaButton>,
  ];

  return (
    <>
      <Segment title="Buttons">
        <div className={s.buttons}>
          <div className={classnames(s.buttons__panel)}>
            {buttons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'brand' })}
              </div>
            ))}
          </div>
          <div className={classnames(s.buttons__panel)}>
            {buttons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'white' })}
              </div>
            ))}
          </div>
          <div className={classnames(s.buttons__panel)}>
            {buttons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'dark' })}
              </div>
            ))}
          </div>
        </div>
      </Segment>
      <Segment title="Buttons">
        <div className={s.buttons}>
          <div className={classnames(s.buttons__panel, s.white)}>
            <div className={s.buttons__title}>Brand (default)</div>
            {buttons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'brand' })}
              </div>
            ))}
          </div>
          <div className={classnames(s.buttons__panel, s.brand)}>
            <div className={s.buttons__title}>White</div>
            {buttons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'white' })}
              </div>
            ))}
          </div>
          <div className={classnames(s.buttons__panel, s.white)}>
            <div className={s.buttons__title}>Dark</div>
            {buttons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'dark' })}
              </div>
            ))}
          </div>
        </div>
        <div className={s.buttons}>
          <div className={classnames(s.buttons__panel, s.white)}>
            <div className={s.buttons__title}>Brand (default)</div>
            {megaButtons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'brand' })}
              </div>
            ))}
          </div>
          <div className={classnames(s.buttons__panel, s.brand)}>
            <div className={s.buttons__title}>White</div>
            {megaButtons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'white', hover: 'dark' })}
              </div>
            ))}
          </div>
          <div className={classnames(s.buttons__panel, s.brand)}>
            <div className={s.buttons__title}>Dark</div>
            {megaButtons.map((component, i) => (
              <div className={s.buttons__button} key={i}>
                {React.cloneElement(component, { color: 'dark' })}
              </div>
            ))}
          </div>
        </div>
      </Segment>
    </>
  );
};
